import { z } from 'zod';
import { xmlValueSchema } from '../xml-value-schema';

export const msatsCombinedStructuredAddressSchema = z
  .object({
    StructuredAddress: z
      .object({
        FlatOrUnit: z
          .object({
            FlatOrUnitType: z.string(),
            FlatOrUnitNumber: z.string(),
          })
          .partial(),
        House: z
          .object({
            HouseNumber: z.string(),
            HouseNumberSuffix: z.string(),
            HouseNumberTo: z.string().optional(),
            HouseNumberToSuffix: z.string().optional(),
          })
          .partial(),
        Street: z
          .object({
            StreetName: z.string(),
            StreetType: z.string(),
          })
          .partial(),
      })
      .partial(),

    PostCode: z.string(),
    StateOrTerritory: z.string(),
    SuburbOrPlaceOrLocality: z.string(),
  })
  .transform((value) => {
    const flatOrUnit = [
      value.StructuredAddress.FlatOrUnit?.FlatOrUnitType,
      value.StructuredAddress.FlatOrUnit?.FlatOrUnitNumber,
    ].join('');

    const house = [
      value.StructuredAddress.House?.HouseNumber,
      value.StructuredAddress.House?.HouseNumberSuffix,
    ].join('');

    const houseTo = [
      value.StructuredAddress.House?.HouseNumberTo,
      value.StructuredAddress.House?.HouseNumberToSuffix,
    ].join('');

    const combineHouse = [house, houseTo].join(' ').trim();

    const street = [
      value.StructuredAddress.Street?.StreetName,
      value.StructuredAddress.Street?.StreetType,
    ].join(' ');

    const StructuredAddress = [flatOrUnit, combineHouse, street].join(' ');

    const full = [
      StructuredAddress,
      value.SuburbOrPlaceOrLocality,
      value.PostCode,
      value.StateOrTerritory,
    ]
      .join(' ')
      .replace(/[ ]+/g, ' ')
      .trim();

    return full;
  });

export type MsatsCombinedStructuredAddressSchema = z.infer<
  typeof msatsCombinedStructuredAddressSchema
>;
